// extracted by mini-css-extract-plugin
export default {"spanPos":"HeaderCart_spanPos__sGgGA","cartHolder":"HeaderCart_cartHolder__Y40v6","linkCart":"HeaderCart_linkCart__QGgyI"};